export const SITE_NAME = 'leadership.NET'
export const SITE_ORIGIN = 'https://leadership.net'
export const JOHN_BEHR_ID = 'https://leaderbridge.com/#john-behr'
export const LEADERSHIP_NET_ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`
export const LEADERBRIDGE_ORGANIZATION_ID = 'https://leaderbridge.com/#organization'

export const PUBLIC_ROUTE_METADATA = {
  '/': {
    title: 'Leadership Breaks Where Decisions Become Action | leadership.NET',
    description:
      'leadership.NET is focused on one thing: how leadership intent moves through an organization and becomes action.',
    canonical: `${SITE_ORIGIN}/`
  },
  '/implementation': {
    title: 'Implementation Support | leadership.NET',
    description:
      'Learn how leadership.NET implementation support protects the correct application of its standards without replacing leadership accountability.',
    canonical: `${SITE_ORIGIN}/implementation`
  },
  '/about': {
    title: 'About John Behr, PhD | leadership.NET',
    description:
      'John Behr, PhD, industrial and organizational psychologist, founded leadership.NET and LeaderBridge to support consequential human leadership.',
    canonical: `${SITE_ORIGIN}/about`
  }
}

export const NOT_FOUND_METADATA = {
  title: 'Page not found | leadership.NET',
  description: 'The requested leadership.NET page could not be found.'
}

export const PRIVATE_ROUTE_PREFIXES = [
  '/login',
  '/auth/',
  '/account/',
  '/dashboard/',
  '/admin/',
  '/payment/',
  '/checkout/',
  '/preview/',
  '/token/'
]

export const normalizePathname = (pathname) => {
  if (pathname === '/') return '/'

  const withoutTrailingSlash = pathname.replace(/\/+$/, '')
  return withoutTrailingSlash || '/'
}

export const getRouteMetadata = (pathname) => {
  const normalizedPathname = normalizePathname(pathname)
  const publicMetadata = Object.entries(PUBLIC_ROUTE_METADATA).find(
    ([route]) => route === normalizedPathname
  )?.[1]

  if (publicMetadata) return { ...publicMetadata, robots: 'index, follow' }

  return {
    ...NOT_FOUND_METADATA,
    robots: 'noindex, nofollow'
  }
}

export const getStructuredData = (pathname) => {
  const normalizedPathname = normalizePathname(pathname)
  const metadata = Object.entries(PUBLIC_ROUTE_METADATA).find(
    ([route]) => route === normalizedPathname
  )?.[1]

  if (!metadata) return null

  const leadershipNetOrganization = {
    '@type': 'Organization',
    '@id': LEADERSHIP_NET_ORGANIZATION_ID,
    name: 'leadership.NET LLC',
    description:
      'leadership.NET defines the architecture beneath how leadership intent is interpreted and becomes action.',
    url: `${SITE_ORIGIN}/`,
    logo: `${SITE_ORIGIN}/leadership-net-logo.svg`,
    founder: { '@id': JOHN_BEHR_ID }
  }
  const johnBehr = {
    '@type': 'Person',
    '@id': JOHN_BEHR_ID,
    name: 'John Behr',
    honorificSuffix: 'PhD',
    jobTitle: 'Industrial and Organizational Psychologist',
    worksFor: [{ '@id': LEADERSHIP_NET_ORGANIZATION_ID }, { '@id': LEADERBRIDGE_ORGANIZATION_ID }],
    sameAs: [
      'https://www.linkedin.com/in/johnbehr',
      'https://spaceas.com/about',
      'https://leadership.net/about',
      'https://leaderbridge.com/about-us'
    ]
  }
  const leaderBridgeOrganization = {
    '@type': 'Organization',
    '@id': LEADERBRIDGE_ORGANIZATION_ID,
    name: 'LeaderBridge LLC',
    description:
      'LeaderBridge helps teams examine how leadership is landing around critical directives before execution.',
    url: 'https://leaderbridge.com/',
    logo: 'https://leaderbridge.com/ln_logo.jpg',
    founder: { '@id': JOHN_BEHR_ID },
    sameAs: ['https://www.linkedin.com/company/leaderbridgeplatform']
  }
  const website = {
    '@type': 'WebSite',
    '@id': `${SITE_ORIGIN}/#website`,
    name: SITE_NAME,
    url: `${SITE_ORIGIN}/`,
    publisher: { '@id': LEADERSHIP_NET_ORGANIZATION_ID }
  }
  const webpage = {
    '@type': normalizedPathname === '/about' ? 'AboutPage' : 'WebPage',
    '@id': `${metadata.canonical}#webpage`,
    url: metadata.canonical,
    name: metadata.title,
    description: metadata.description,
    publisher: { '@id': LEADERSHIP_NET_ORGANIZATION_ID },
    isPartOf: { '@id': `${SITE_ORIGIN}/#website` },
    ...(normalizedPathname === '/about' ? { mainEntity: { '@id': JOHN_BEHR_ID } } : {})
  }

  return {
    '@context': 'https://schema.org',
    '@graph': [leadershipNetOrganization, leaderBridgeOrganization, johnBehr, website, webpage]
  }
}
